module.exports = __webpack_public_path__ + "static/acupuncture-in-west-loop-abd8863e789ce503cb4daa2bd616f7d9.webp";